import { Card, NumberField } from '@/components/ui'
import type { AccountIn } from '@/lib/types'

/** Devises acceptées comme devise de compte : celles de nos 28 paires. */
const CURRENCIES = ['EUR', 'USD', 'GBP', 'CHF', 'JPY', 'AUD', 'NZD', 'CAD']

/**
 * Paramètres du compte.
 *
 * En mode CALCULATEUR ils sont saisis à la main : il n'y a pas de broker pour
 * les fournir. Dès l'étape 4, ce panneau affichera les valeurs réelles du
 * compte (balance, equity, marge libre, levier) en lecture seule.
 */
export function AccountPanel({
  account,
  onChange,
}: {
  account: AccountIn
  onChange: (account: AccountIn) => void
}) {
  return (
    <Card title="Compte">
      <div className="grid grid-cols-3 gap-2 p-3">
        <label className="block">
          <span className="mb-1 block text-[11px] uppercase tracking-wide text-ink-muted">
            Devise
          </span>
          <select
            value={account.currency}
            onChange={(event) => onChange({ ...account, currency: event.target.value })}
            className="num min-h-touch w-full rounded-md border border-border bg-elevated px-2 text-ink outline-none"
          >
            {CURRENCIES.map((currency) => (
              <option key={currency} value={currency}>
                {currency}
              </option>
            ))}
          </select>
        </label>

        <NumberField
          label="Capital"
          value={account.balance}
          onChange={(balance) => onChange({ ...account, balance })}
        />

        <label className="block">
          <span className="mb-1 block text-[11px] uppercase tracking-wide text-ink-muted">
            Levier
          </span>
          <select
            value={account.leverage}
            onChange={(event) => onChange({ ...account, leverage: Number(event.target.value) })}
            className="num min-h-touch w-full rounded-md border border-border bg-elevated px-2 text-ink outline-none"
          >
            {[1, 2, 5, 10, 20, 30, 50, 100, 200, 500].map((leverage) => (
              <option key={leverage} value={leverage}>
                {leverage}:1
              </option>
            ))}
          </select>
        </label>
      </div>
    </Card>
  )
}
